"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _checkEmail = require("./checkEmail");
Object.keys(_checkEmail).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _checkEmail[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _checkEmail[key];
    }
  });
});
var _authenticate = require("./authenticate");
Object.keys(_authenticate).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _authenticate[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _authenticate[key];
    }
  });
});
var _twoFactor = require("./twoFactor");
Object.keys(_twoFactor).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _twoFactor[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _twoFactor[key];
    }
  });
});
var _restore = require("./restore");
Object.keys(_restore).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _restore[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _restore[key];
    }
  });
});